import headerTop from "@/components/HeaderTop";
import { debounce } from "@/utils/debounce";

import {
  getCustomerInfo,
  getFinishes,
  getFollows,
  addFollow,
  getContracts,
  addContract,
  updateContract,
  getCustomerPhone,
  getContractPhone,
  updateAttentionLevel,
  getHistorypages,
  getHistoryActions,
  deleteContract
} from "@/http/api/customer";
import {
  deepCopy
} from "@/utils/deepCopy";
import {
  getCustomerReservations,
  getReservations,
  addNetSign,
  uploadNetSignMaterials,
} from "@/http/api/reservations";
import {
  validatePhone
} from "@/utils/validate";
import {
  customerSettings
} from "@/http/api/system";
import {
  dateFormat
} from "@/common/filters";
import {
  getEnumValues
} from "@/utils/getEnumMeta";

export default {
  components: {
    headerTop,
  },
  data() {
    const validatePhoneNumber = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入手机号"));
      } else if (!validatePhone(value)) {
        callback(new Error("手机号输入不正确"));
      } else {
        callback();
      }
    };
    const validatePhone2Number = (rule, value, callback) => {
      if (!value) {
        callback();
      } else if (!validatePhone(value)) {
        callback(new Error("手机号输入不正确"));
      } else {
        callback();
      }
    };
    return {
      defaultCover: require("@/assets/image/estate-cover.jpg"),
      searchText: "请输入操作人名称/内容",
      searchValue: "",
      search: "前缀搜索",
      id: '',
      contractTitle: '',
      contractId: '',
      reportId: '',
      houseName: '',
      historyTitle:'',
      historyContent:'',
      isSelectReportShow: false,
      isShowPhone: false,
      isFollowShow: false,
      isLoading: false,
      isContractShow: false,
      isLogShow: false,
      isAttentionLevelShow: false,
      isNetSignShow: false,
      canLookContract: false,
      isHistoryShow:false,
      customerPhone: '',
      customerPhoneDefault: '',
      pageIndex: 1,
      totalCount:0,
      queryLog: {
        customerId: '',
        filter: '',
        condition: '',
        startTime: '',
        endTime: '',
        actionCode: '',
        skipCount: '',
        sorting:'',
        maxResultCount: 10
      },
      customer: {
        phoneNumber: '',
        houseTypes: [],
        addresses: [],
        floorTypes: [],
        decorations: [],
        schools: [],
        communities: [],
        orientationType: [],
      },
      followForm: {
        purpose: '',
        content: ''
      },
      contractForm: {
        name: "",
        gender: "女",
        phone1: "",
        phone2: "",
        weChat: "",
        qq: "",
        more: "",
        phoneNumbers: [],
      },
      netSignForm: {
        reportId: '',
        netSignTime: "",
        price: '',
        more: "",
        buildingNumber: '',
        unitNumber: '',
        houseNumber: '',
      },
      attentionLevelForm: {
        attentionLevel: ''
      },
      historyList: [],
      searchOptions: [{
          value: "operatorName",
          label: "操作人名称",
        },
        {
          value: "content",
          label: "内容",
        },
        {
          value: "",
          label: "全文搜索",
        }
      ],
      netSignFiles: [],
      reservations: [],
      finishes: [],
      follows: [],
      contracts: [{
        phoneNumbers: []
      }],
      historyActions: [],
      contractsAll: [],
      contractsDefault: [],
      netSignRules: {
        unitNumber: [{
          required: true,
          trigger: "blur",
          message: "请输入单元"
        }],
        buildingNumber: [{
          required: true,
          trigger: "blur",
          message: "请输入楼栋"
        }],
        houseNumber: [{
          required: true,
          trigger: "blur",
          message: "请输入房号"
        }],
        price: [{
          required: true,
          trigger: "blur",
          message: "请输入成交价格"
        }],
        netSignTime: [{
          required: true,
          trigger: "change",
          message: "请选择成交日期"
        }],
        netSignTime: [{
          required: true,
          trigger: "change",
          message: "请选择成交日期"
        }],
        reportId: [{
          required: true,
          trigger: "change",
          message: "请选择报备单"
        }]
      },
      attentionLevelRules: {
        attentionLevel: [{
          required: true,
          trigger: "change",
          message: "请选择客户等级"
        }]
      },
      followRules: {
        purpose: [{
          required: true,
          trigger: "change",
          message: "请选择跟进目的"
        }],
        content: [{
          required: true,
          trigger: "blur",
          message: "请输入跟进内容"
        }],
      },
      contractRules: {
        name: [{
          required: true,
          trigger: "blur",
          message: "请输入姓名",
        }, ],
        gender: [{
          required: true,
          trigger: "change",
          message: "请选择性别",
        }, ],
        phone1: [{
          required: true,
          trigger: "blur",
          validator: validatePhoneNumber,
        }, ],
        phone2: [{
          required: false,
          trigger: "blur",
          validator: validatePhone2Number
        }, ],
        weChat: [{
          required: false
        }],
        qq: [{
          required: false
        }],
        more: [{
          required: false
        }],
      },
      permissions: {},
      purposeOptions: [],
      genderOptions: ["男", "女"],
      attentionLevelOptions: [],
      reports: [],
      selsetReports: [],
      dateRange: [],
      reservationEstates:[]
    }
  },

  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.permissions = this.$store.getters.permissions;
      this.getCustomerInfo();
      this.getReservations();
      this.getFinishes();
      this.getFollows();
      this.initSettings();
      if (this.permissions['Customer.LookContract']) {
        this.canLookContract = true;
        this.getContracts();
      } else {
        this.canLookContract = false;
      }
      if (this.permissions['Customer.LookPhoneNumber']) {
        getCustomerPhone(this.id).then(res => {
          //console.log(res, '电话');
          this.customerPhone = res.result;
        })
        getContractPhone(this.id).then(res => {
          //console.log(res, '联系人');
          this.contractsAll = res.result.items;
        })
      }
    },
    // 查看详情
    lookDetail(v){
      this.historyTitle=v.actionName;
      this.historyContent=v.content;
      this.isHistoryShow=true;
    },
    changeSort(val) {
      //console.log(val, 555);
      this.queryLog.sorting =
        val.order == "descending"
          ? `${val.prop} desc`
          : val.order == "ascending"
          ? `${val.prop} asc`
          : "";
      this.getHistorypages();
    },
    clearHistoryFilter(){
      Object.assign(this.$data.queryLog, this.$options.data().queryLog);
      this.searchText="请输入操作人名称/内容";
      this.searchValue='';
      this.search= "前缀搜索";
      this.pageIndex=1;
      this.dateRange=[];
      this.$refs.historyTable.clearSort();
      this.getHistorypages();
    },
    // 更改的页面数量
    handleSizeChange(val) {
      this.queryLog.maxResultCount = val;
      this.getHistorypages();
    },
    // 跳转的指定页
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getHistorypages();
    },
    actionCodeFilter(v){
      let str='—';
      this.historyActions.map(el=>{
        if (v==el.actionCode) {
          str=el.actionName;
        }
      })
      return str
    },
    getHistoryActions() {
      getHistoryActions().then(res => {
        this.historyActions = res.result;
      })
    },
    handleSelectionChange(val) {
      this.selsetReports = val;
    },
    dateRangeChange(v) {
      if (v) {
        this.queryLog.startTime = dateFormat(v[0]);
        this.queryLog.endTime = dateFormat(v[1]);
      } else {
        this.queryLog.startTime = '';
        this.queryLog.endTime = '';
      }
      this.getHistorypages();
    },
    // 提交选择报备
    submitSelectReport() {
      if (!this.selsetReports.length) {
        this.$message.warning({
          message: `请选择报备单`,
          showClose: true,
        });
      } else if (this.selsetReports.length > 1) {
        this.$message.warning({
          message: `只能选择一个报备单`,
          showClose: true,
        });
      } else {
        let data = this.selsetReports[0];
        this.houseName = data.estateName;
        this.reportId = data.id;
        this.netSignForm.reportId = data.id;
        this.isSelectReportShow = false;
      }
    },
    // 客户成交
    customerDeal() {
      if (this.permissions["Reservation.NetSignSubmit"]) {
        let data = {
          flowStatus: 'recognition',
          condition: 'customerName',
          filter: this.customer.name,
          maxResultCount: 1000
        }
        getReservations(data).then(res => {
          this.reports = res.result.items;
          if (this.reports.length) {
            this.isNetSignShow = true;
          } else {
            this.$message.warning({
              message: `该客户名下暂无可成交的报备单`,
              showClose: true,
            });
          }
        })
      } else {
        this.$message.warning({
          message: `您暂无添加客户成交权限`,
          showClose: true,
        });
      }
    },
    // 删除成交图片
    delDealImg(index) {
      this.netSignFiles.splice(index, 1);
    },
    // 修改客户等级
    editFollowLevel() {
      if (this.permissions['Customer.Update']) {
        this.isAttentionLevelShow = true;
      } else {
        this.$message.warning({
          message: "您暂无修改客户权限",
          showClose: true,
        });
      }
    },
    // 客户成交上传附件
    handleNetSignPreview(file) {
      if (this.netSignFiles.length < 5) {
        this.netSignFiles.push({
          file: file.raw,
          url: URL.createObjectURL(file.raw),
        });
      } else {
        this.$message({
          message: "最多只允许上传5张图片",
          showClose: true,
        });
      }
    },
    // 提交客户成交
    submitNetSign() {
      this.$refs["netSignForm"].validate((valid) => {
        if (valid) {
          this.isLoading = true;
          let data = deepCopy(this.netSignForm);
          delete data.reportId;
          data.netSignTime = dateFormat(data.netSignTime);

          addNetSign(this.reportId, data).then((res) => {
            //console.log(res, 666);
            if (this.netSignFiles.length) {
              let formData = new FormData();
              this.netSignFiles.map((el, i) => {
                formData.append(`materials[${i}]`, el.file);
              });
              uploadNetSignMaterials(this.reportId, res.result, formData).then(re => {
                this.isLoading = false;
                this.isNetSignShow = false;
                this.$message.success({
                  message: "提交成功",
                  showClose: true
                });
              });
            } else {
              this.isLoading = false;
              this.isNetSignShow = false;
              this.$message.success({
                message: "提交成功",
                showClose: true
              });
            }
          });
        } else {
          //console.log("表单验证未通过");
          return false;
        }
      });
    },
    // 基础配置项初始化
    initSettings() {
      customerSettings().then((res) => {
        let data = res.result;
        this.purposeOptions = getEnumValues(data, "Deer.Customer.Collection.FlowPurposeType");
        this.attentionLevelOptions = getEnumValues(data, "Deer.Customer.Collection.AttentionLevelType");
        //console.log(this.attentionLevelOptions, 'this.attentionLevelOptions');
      });
    },
    // 提交客户等级
    submitAttentionLevel() {
      this.$refs["attentionLevelForm"].validate((valid) => {
        if (valid) {
          this.isLoading = true;
          let leval = this.attentionLevelForm.attentionLevel;
          updateAttentionLevel(this.id, leval).then(res => {
            this.getCustomerInfo();
            this.isAttentionLevelShow = false;
            this.isLoading = false;
            this.$message.success({
              message: "修改成功",
              showClose: true
            });
          })
        } else {
          //console.log("表单验证未通过");
          return false;
        }
      });
    },
    // 查看操作日志
    lookLog() {
      if (this.permissions['AuditLogging.ViewChangeHistory:Deer.Customers.Customer']) {
        if (!this.historyActions.length) {
          this.getHistoryActions();
        }
        this.$watch(
          "searchValue",
          debounce(() => {
            this.getHistorypages();
          }, 200)
        );
        this.getHistorypages();
        this.isLogShow = true;
      }else{
        this.$message.warning({
          message: "您暂无查看客户/联系人操作日志权限",
          showClose: true,
        });
      }
    },
    getHistorypages() {
      this.queryLog.customerId = this.id;
      this.queryLog.skipCount = (this.pageIndex - 1) * this.queryLog.maxResultCount;
      this.queryLog.filter = this.searchValue;
      getHistorypages(this.queryLog).then(res => {
        //console.log(res, 888);
        this.historyList = res.result.items;
        this.totalCount=res.result.totalCount;
      })
    },
    // 搜索前置条件
    filterSelect(val) {
      switch (val) {
        case "operatorName":
          this.searchText = "请输入操作人名称";
          break;
        case "content":
          this.searchText = "请输入内容";
          break;
        case "":
          this.searchText = "请输入操作人名称/内容";
          break;
      }
      this.queryLog.condition = val;
    },
    // 写跟进
    addFollow() {
      if (this.permissions['Customer.AddFlowRecord']) {
        this.isFollowShow = true;
      } else {
        this.$message.warning({
          message: "您暂无填写跟进权限",
          showClose: true,
        });
      }
    },
    // 切换隐藏/显示手机号
    switchShowPhone(v) {
      if (this.permissions['Customer.LookPhoneNumber']) {
        this.isShowPhone = v;
        if (v) {
          this.customer.phoneNumber = this.customerPhone;
          this.contracts = this.contractsAll;
        } else {
          this.customer.phoneNumber = this.customerPhoneDefault;
          this.contracts = this.contractsDefault;
        }
      } else {
        this.$message.warning({
          message: "您暂无查看手机号权限",
          showClose: true,
        });
      }
    },
    addContract() {
      if (this.permissions['Customer.AddContract']) {
        Object.assign(this.$data.contractForm, this.$options.data().contractForm);
        this.contractTitle = '添加联系人';
        this.isContractShow = true;
      } else {
        this.$message.warning({
          message: "您暂无添加联系人权限",
          showClose: true,
        });
      }
    },
    editContract(v) {
      if (this.permissions['Customer.UpdateContract']) {
        if (this.permissions['Customer.LookPhoneNumber']) {
          let phones=[];
          this.contractsAll.map(el=>{
            if (el.id==v.id) {
              phones=el.phoneNumbers
            }
          })
          this.contractTitle = '编辑联系人';
          v.phone1 = phones[0];
          v.phone2 = "";
          if (phones[1]) {
            v.phone2 = phones[1];
          }
          this.contractForm = deepCopy(v);
          this.isContractShow = true;
        }else{
          this.$message.warning({
            message: "您暂无查看联系人手机号权限，无法编辑",
            showClose: true,
          });
        }
      } else {
        this.$message.warning({
          message: "您暂无编辑联系人权限",
          showClose: true,
        });
      }
    },
    // 提交联系人表单
    submitContractForm() {
      this.$refs["contractForm"].validate((valid) => {
        if (valid) {
          let data = deepCopy(this.contractForm);
          data.phoneNumbers = [data.phone1];
          if (data.phone2) {
            data.phoneNumbers.push(data.phone2);
          }
          delete data.phone1;
          delete data.phone2;
          this.isLoading = true;
          if (this.contractTitle == "添加联系人") {
            addContract(this.id, data).then(res => {
              this.getContracts();
              this.isContractShow = false;
              this.isLoading = false;
              if (res) {
                this.$message.success({
                  message: "添加成功",
                  showClose: true
                });
              }
            })
          } else {
            updateContract(this.id, data.id, data).then(res => {
              this.getContracts();
              this.isContractShow = false;
              this.isLoading = false;
              if (res) {
                this.$message.success({
                  message: res.message,
                  showClose: true
                });
              }
            })
          }
        } else {
          //console.log("表单验证未通过");
          return false;
        }
      });
    },
    // 跳转楼盘详情
    goEstateDetail(id) {
      this.$router.push("/estate/detail/" + id);
    },
    // 跳转报备详情
    goReservationDetail(id) {
      this.$router.push("/reservation/detail/" + id);
    },
    // 编辑客源
    editCustomer() {
      if (this.permissions['Customer.Update']) {
        this.$router.push("/customer/update/" + this.id);
      } else {
        this.$message.warning({
          message: "您暂无编辑客源权限",
          showClose: true,
        });
      }
    },
    // 获取客源详情
    getCustomerInfo() {
      this.id = this.$route.params.id;
      getCustomerInfo(this.id).then(res => {
        this.customer = res.result;
        this.customerPhoneDefault = res.result.phoneNumber;
      })
    },
    // 获取报备列表
    getReservations() {
      getCustomerReservations(this.id).then(res => {
        this.reservations = res.result.items;
        let arr=[];
        this.reservations.map(el=>{
          arr.push(el.estateName)
        })
        this.reservationEstates=[...new Set(arr)];
      })
    },
    // 获取成交信息列表
    getFinishes() {
      getFinishes(this.id).then(res => {
        //console.log(res, 'getFinishes');
        this.finishes = res.result.items;
      })
    },
    // 获取跟进记录列表
    getFollows() {
      getFollows(this.id).then(res => {
        this.follows = res.result.items;
      })
    },
    submitFollow() {
      this.$refs["followForm"].validate((valid) => {
        if (valid) {
          this.isLoading = true;
          let data = deepCopy(this.followForm);
          addFollow(this.id, data).then(res => {
            this.getFollows();
            this.isLoading = false;
            this.isFollowShow = false;
          }).catch(() => {
            this.isLoading = false;
          })
        } else {
          //console.log("表单验证未通过");
          return false;
        }
      });
    },
    // 弹窗关闭回调
    handleClose(formName) {
      if (formName == 'netSignForm') {
        this.houseName = '';
        this.netSignFiles = [];
        this.$refs[formName].resetFields();
      } else if (formName == 'log') {
        this.clearHistoryFilter();
      } else if (formName == 'selectReport') {
        this.$refs.reportTable.clearSelection();
      } else {
        this.$refs[formName].resetFields();
      }
    },
    delContract(id){
      if (this.permissions['Customer.DeleteContract']) {
        this.$confirm(
            `确定删除此联系人？删除后联系人将不存在，请谨操作！`,
            "温馨提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
            }
          )
          .then(() => {
            deleteContract(this.id,id).then((res) => {
              this.getContracts();
              if (res) {
                this.$message.success({
                  message: "删除成功",
                  showClose: true
                });
              }
            });
          })
          .catch(() => {
            //console.log("已取消");
          });
      } else {
        this.$message.warning({
          message: "您暂无删除客户权限",
          showClose: true,
        });
      }
    },
    // 获取联系人列表
    getContracts() {
      getContracts(this.id).then(res => {
        this.contracts = res.result.items;
        this.contractsDefault = res.result.items;
      })
    }
  }
};